import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

class AppDropdown extends React.Component {
  state = {
    isDroppedDown: false,
  };

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      this.setState({
        isDroppedDown: false,
      });
    }
  };

  render() {
    let dropdownClass = classNames({
      dropdown: true,
      "dropdown--is-visible": this.state.isDroppedDown,
    });
    return (
      <li className="other-apps__app-icon app-icon--apps apps-dropdown">
        <button
          target="_blank"
          rel="noopener noreferrer"
          alt="app"
          onClick={this.toggleDropdown}
          className="apps-links has-dropdown cpanel-tooltip"
        >
          <img
            alt="All apps dropdown Icon"
            src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-apps-icon.svg"
            className="app-icon app-icon-wordpress"
          />
          <span className="tooltiptext">Other apps</span>
        </button>
        <ul id="apps__dropdown" className={dropdownClass}>
          {this.props.starredApps.length === 0 &&
            this.props.apps.length === 0 && (
              <div className="apps-label">
                <span className="apps-label__title">No Apps Enabled.</span>
              </div>
            )}
          {this.props.starredApps.length > 0 && (
            <div>
              {this.props.starredApps.map((app, i) => (
                <li className="apps__dropdown--item" key={i}>
                  <a
                    href={app.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="app"
                    className=""
                  >
                    <img
                      alt={app.title}
                      src={app.image}
                      className="app-icon app-icon-gmail"
                    />
                    <span>{app.title.split(" ").slice(0, 2).join(" ")}</span>
                    {app.badge && (
                      <span className="mail-badge">{app.badge}</span>
                    )}
                  </a>
                </li>
              ))}
            </div>
          )}
          {this.props.apps.length > 0 && (
            <div>
              <div className="apps-label apps-label--margin-top">
                <span className="apps-label__title">Other Apps</span>
              </div>
              {this.props.apps.map((app, i) => (
                <li className="apps__dropdown--item" key={i}>
                  <a
                    href={app.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="app"
                    className=""
                  >
                    <img
                      alt={app.title}
                      src={app.image}
                      className="app-icon app-icon-gmail"
                    />
                    <span>{app.title}</span>
                    {app.badge && (
                      <span className="mail-badge">{app.badge}</span>
                    )}
                  </a>
                </li>
              ))}
            </div>
          )}
        </ul>
      </li>
    );
  }
}

export default AppDropdown;
